import { useEffect } from 'react';
import { useStore } from '@/state/store';
import { saveTheme } from '@/state/persistence';

export function useTheme() {
  const theme = useStore((s) => s.ui.theme);

  useEffect(() => {
    const root = document.documentElement;
    const media = window.matchMedia('(prefers-color-scheme: dark)');

    const apply = () => {
      const dark = theme === 'dark' || (theme === 'system' && media.matches);
      root.setAttribute('data-theme', dark ? 'dark' : 'light');
      // index.html ships one theme-color per colour scheme so the browser
      // chrome is right before this ever runs; once the choice is explicit,
      // both have to carry it or the OS setting would win back.
      document
        .querySelectorAll('meta[name="theme-color"]')
        .forEach((meta) => meta.setAttribute('content', dark ? '#171719' : '#f5f5f7'));
    };

    apply();
    saveTheme(theme);
    if (theme !== 'system') return;
    media.addEventListener('change', apply);
    return () => media.removeEventListener('change', apply);
  }, [theme]);
}
